import css from './paper.module.scss';
import {PaperProps} from './paper.types';

export const Paper = ({children}: PaperProps): JSX.Element => {
	return <div className={css.container}>{children}</div>;
};
